import { cn } from "@/utils/cn";

type BriefTextProps = {
  /** Shown (muted) when the value is empty. */
  placeholder: string;
  value: string;
};

/** Read-only view of a templated brief field, line breaks preserved. */
export function BriefText({ placeholder, value }: BriefTextProps) {
  return (
    <p
      className={cn(
        "whitespace-pre-wrap text-sm leading-relaxed text-text-secondary",
        !value && "italic text-text-tertiary",
      )}
    >
      {value || placeholder}
    </p>
  );
}
